<div class="flex justify-end items-center text-white text-sm">
  <span>SPORTS FOR MORE e.V.</span>
</div>

<div class="mb-4 mt-12">
  <span class="text-xl text-white">Hej, {{ userStore.user()?.firstname }} 👋</span>
</div>
